import React, {Component} from 'react';
import GraduateCard from '../components/Cards/GraduateCard';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet';

import PageHeader from '../components/Headers/PageHeader';
import Filter from '../components/Filter';

const headerContent = {
    tag: 'Check out our',
    title: 'Graduates',
    description: 'The graduating cohort from Design Computing and MIDEA represent the next generation of innovators. Find out more about them here.'
};

class GraduatePage extends Component {
    render() {
        return (
            <div className={'container'}>
                <Helmet>
                    <title>Graduates • D18</title>
                </Helmet>
                <PageHeader color={'green'} content={headerContent}/>
                <Filter emptyMsg={'— No graduates found —'}>
                    {this.props.graduates.map((graduate, i) => {
                        return (
                            <GraduateCard graduate={graduate} key={i}/>
                        )
                    })}
                </Filter>
            </div>
        )
    }
}

const MapStateToProps = (state) => ({
    graduates: state.graduates,
});
export default connect(MapStateToProps)(GraduatePage);